const environments = {
  ngrok: "https://injurycapture-webapp.sa.ngrok.io",
  development: "http://localhost:3000",
  staging: "https://stageapp.kulpacloud.com"
};

export const baseUrl =
  process.env.REACT_APP_APP_URL ||
  environments[process.env.REACT_APP_NGROK || process.env.NODE_ENV] ||
  environments.staging;

// Keycloak
export const authority =
  process.env.REACT_APP_AUTHORITY ||
  "https://keycloak.thankfultree-219d8f5a.uksouth.azurecontainerapps.io/realms/kulpa";

export const clientId = "kulpa-frodo";

export const scope = "openid profile cases";

export const redirectUri = `${baseUrl}/callback`;
export const postLogoutRedirectUri = `${baseUrl}/logout`;
